/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class MemberService extends __BaseService {
  static readonly memberLoginPath = '/auth/login';
  static readonly registerMemberPath = '/auth/register';
  static readonly forgotPasswordPath = '/auth/forgotpassword';
  static readonly resetPasswordPath = '/auth/password';
  static readonly verifyPath = '/member/verify';
  static readonly resendCodePath = '/member/resendCode';
  static readonly getMembersPath = '/member';
  static readonly getProfilePath = '/profile';
  static readonly updateMemberPath = '/member/update';
  static readonly changePasswordPath = '/member/reset-password';
  static readonly getMemberSpacePath = '/member/space';
  static readonly createMemberSpacePath = '/member/space';
  static readonly getMemberSpaceDetailsPath = '/member/space/{id}';
  static readonly updateMemberSpacePath = '/member/space/{id}';
  static readonly deleteMemberSpacePath = '/member/space/{id}';
  static readonly deleteFloorplanPath = '/floorplan/{id}';
  static readonly getMemberSpaceMediaDetailsPath = '/space/{id}/media';
  static readonly getHotspotListPath = '/space/{id}/hotspot';
  static readonly getInfoHotspotListPath = '/space/{id}/infohotspot';
  static readonly deleteMultipleImagePath = '/space/{id}/media/bulkDelete';
  static readonly validateSpaceObjectPath = '/member/space/validate/{id}';
  static readonly verifyEmailPath = '/activate/link/{id}';
  static readonly getSpaceCategoryPath = '/space/category';
  static readonly getCompanyListPath = '/company';
  static readonly createHotspotPath = '/media/hotspot';
  static readonly updateHotspotPath = '/media/hotspot/{id}';
  static readonly deleteHotspotPath = '/media/hotspot/{id}';
  static readonly updateSpaceConfigPath = '/space/config/{id}';
  static readonly setInitialViewPath = '/space/media/{id}/initialView';
  static readonly publishSpacePath = '/member/space/{id}/status';
  static readonly showHideInfoPath = '/media/spaceinfo/{id}/toggle';
  static readonly createInfoHotspotPath = '/media/spaceinfo';
  static readonly updateInfoHotspotPath = '/media/spaceinfo/{id}';
  static readonly deleteInfoHotspotPath = '/media/spaceinfo/{id}';
  static readonly getInvoicesPath = '/invoice';
  static readonly getPaymentCardPath = '/card';
  static readonly getCurrentSubscriptionPath = '/subscription';
  static readonly getFloorPlanPath = '/spaces/{id}/floorplan';
  static readonly createFlooplanHotspotPath = '/floorplan/{id}/hotspot';
  static readonly updateFlooplanHotspotPath = '/floorplan/hotspot/{id}';
  static readonly deleteFloorplanHotspotPath = '/floorplan/hotspot/{id}';
  static readonly addCameraSubscriptionPath = '/camera';
  static readonly updateMediaTitlePath = '/space/media/{id}';
  static readonly deleteSingleMediaPath = '/space/media/{id}';
  static readonly removeCameraSubscriptionPath = '/camera/remove';
  static readonly downloadInvoicePath = '/invoice/{id}/pdf';
  static readonly enableDisableVrLinksPath = '/vrtoggle';
  static readonly setMediaOrientationPath = '/space/media/{mediaId}/orientation';
  static readonly deleteInfoMediaPath = '/spaceinfo/{id}/media';
  static readonly validateReuploadSpaceObjectPath = '/member/space/reuploadValidate/{id}';
  static readonly requestNewDollhousePath = '/space/processfile';
  static readonly deleteAudioSpacePath = '/member/space/audio/{id}';
  static readonly getSnapshotListPath = '/{id}/snapshot';
  static readonly deleteSnapshotsPath = '/snapshot/{id}';
  static readonly deleteMultipleSnapshotsPath = '/snapshot/bulkDelete';
  static readonly getHighlightReelListPath = '/{id}/highlightReel';
  static readonly postHighlightReelPath = '/highlightReel';
  static readonly postHighlightReelCaptionPath = '/highlightReel/{id}';
  static readonly deleteHighlightReelPath = '/highlightReel/{id}';
  static readonly postHighlightReelPositionPath = '/highlightReel/position';
  static readonly updateHotspotOrientationPath = '/media/hotspot/{id}/orientation';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Login member.
   * @param body Login member
   */
  memberLoginResponse(body: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/auth/login`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Login member.
   * @param body Login member
   */
  memberLogin(body: {}): __Observable<null> {
    return this.memberLoginResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Register member.
   * @param body Register member
   */
  registerMemberResponse(body: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/auth/register`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Register member.
   * @param body Register member
   */
  registerMember(body: {}): __Observable<null> {
    return this.registerMemberResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Forgot password member.
   * @param forgotPassword List of member object for forgot password
   */
  forgotPasswordResponse(forgotPassword?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = forgotPassword;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/auth/forgotpassword`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Forgot password member.
   * @param forgotPassword List of member object for forgot password
   */
  forgotPassword(forgotPassword?: {}): __Observable<null> {
    return this.forgotPasswordResponse(forgotPassword).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Reset password of member.
   * @param body Member object for reset password
   */
  resetPasswordResponse(body?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/auth/password`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Reset password of member.
   * @param body Member object for reset password
   */
  resetPassword(body?: {}): __Observable<null> {
    return this.resetPasswordResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * verify email address of member.
   * @param code String ID of the token to verify member.
   */
  verifyResponse(code: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (code != null) __params = __params.set('code', code.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member/verify`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * verify email address of member.
   * @param code String ID of the token to verify member.
   */
  verify(code: string): __Observable<null> {
    return this.verifyResponse(code).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * resend verify code in email address of member.
   * @param email email address of member.
   */
  resendCodeResponse(email: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (email != null) __params = __params.set('email', email.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member/resendCode`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * resend verify code in email address of member.
   * @param email email address of member.
   */
  resendCode(email: string): __Observable<null> {
    return this.resendCodeResponse(email).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get member profile.
   * @param Authorization undefined
   */
  getMembersResponse(Authorization: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get member profile.
   * @param Authorization undefined
   */
  getMembers(Authorization: string): __Observable<null> {
    return this.getMembersResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get member profile.
   * @param Authorization undefined
   */
  getProfileResponse(Authorization: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/profile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get member profile.
   * @param Authorization undefined
   */
  getProfile(Authorization: string): __Observable<null> {
    return this.getProfileResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update member profile.
   * @param params The `MemberService.UpdateMemberParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Update member profile object
   */
  updateMemberResponse(params: MemberService.UpdateMemberParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/member/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update member profile.
   * @param params The `MemberService.UpdateMemberParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Update member profile object
   */
  updateMember(params: MemberService.UpdateMemberParams): __Observable<null> {
    return this.updateMemberResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update password member.
   * @param params The `MemberService.ChangePasswordParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Update member password object
   */
  changePasswordResponse(params: MemberService.ChangePasswordParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/member/reset-password`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update password member.
   * @param params The `MemberService.ChangePasswordParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Update member password object
   */
  changePassword(params: MemberService.ChangePasswordParams): __Observable<null> {
    return this.changePasswordResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get list of spaces of member.
   * @param params The `MemberService.GetMemberSpaceParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Pagination value for member space list.
   *
   * - `Authorization`:
   *
   * - `status`: Status of Space.
   *
   * - `keywords`: Keywords value for filter.
   *
   * - `category_id`: Category value for filter.
   */
  getMemberSpaceResponse(params: MemberService.GetMemberSpaceParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.paginate != null) __params = __params.set('paginate', params.paginate.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.status != null) __params = __params.set('status', params.status.toString());
    if (params.keywords != null) __params = __params.set('keywords', params.keywords.toString());
    if (params.categoryId != null) __params = __params.set('category_id', params.categoryId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member/space`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get list of spaces of member.
   * @param params The `MemberService.GetMemberSpaceParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Pagination value for member space list.
   *
   * - `Authorization`:
   *
   * - `status`: Status of Space.
   *
   * - `keywords`: Keywords value for filter.
   *
   * - `category_id`: Category value for filter.
   */
  getMemberSpace(params: MemberService.GetMemberSpaceParams): __Observable<null> {
    return this.getMemberSpaceResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Create space of member.
   * @param params The `MemberService.CreateMemberSpaceParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Create member space object
   */
  createMemberSpaceResponse(params: MemberService.CreateMemberSpaceParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/member/space`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Create space of member.
   * @param params The `MemberService.CreateMemberSpaceParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Create member space object
   */
  createMemberSpace(params: MemberService.CreateMemberSpaceParams): __Observable<null> {
    return this.createMemberSpaceResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update spaces of member.
   * @param params The `MemberService.GetMemberSpaceDetailsParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  getMemberSpaceDetailsResponse(params: MemberService.GetMemberSpaceDetailsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member/space/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update spaces of member.
   * @param params The `MemberService.GetMemberSpaceDetailsParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  getMemberSpaceDetails(params: MemberService.GetMemberSpaceDetailsParams): __Observable<null> {
    return this.getMemberSpaceDetailsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update spaces of member.
   * @param params The `MemberService.UpdateMemberSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update member space object
   */
  updateMemberSpaceResponse(params: MemberService.UpdateMemberSpaceParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/member/space/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update spaces of member.
   * @param params The `MemberService.UpdateMemberSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update member space object
   */
  updateMemberSpace(params: MemberService.UpdateMemberSpaceParams): __Observable<null> {
    return this.updateMemberSpaceResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete spaces of member.
   * @param params The `MemberService.DeleteMemberSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteMemberSpaceResponse(params: MemberService.DeleteMemberSpaceParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/member/space/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete spaces of member.
   * @param params The `MemberService.DeleteMemberSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteMemberSpace(params: MemberService.DeleteMemberSpaceParams): __Observable<null> {
    return this.deleteMemberSpaceResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete floorplan image.
   * @param params The `MemberService.DeleteFloorplanParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteFloorplanResponse(params: MemberService.DeleteFloorplanParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/floorplan/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete floorplan image.
   * @param params The `MemberService.DeleteFloorplanParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteFloorplan(params: MemberService.DeleteFloorplanParams): __Observable<null> {
    return this.deleteFloorplanResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update spaces of member.
   * @param params The `MemberService.GetMemberSpaceMediaDetailsParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getMemberSpaceMediaDetailsResponse(params: MemberService.GetMemberSpaceMediaDetailsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/space/${encodeURIComponent(String(params.id))}/media`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update spaces of member.
   * @param params The `MemberService.GetMemberSpaceMediaDetailsParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getMemberSpaceMediaDetails(params: MemberService.GetMemberSpaceMediaDetailsParams): __Observable<null> {
    return this.getMemberSpaceMediaDetailsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Hotspot list of spaces.
   * @param params The `MemberService.GetHotspotListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getHotspotListResponse(params: MemberService.GetHotspotListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/space/${encodeURIComponent(String(params.id))}/hotspot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Hotspot list of spaces.
   * @param params The `MemberService.GetHotspotListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getHotspotList(params: MemberService.GetHotspotListParams): __Observable<null> {
    return this.getHotspotListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Infohotspot list of spaces.
   * @param params The `MemberService.GetInfoHotspotListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getInfoHotspotListResponse(params: MemberService.GetInfoHotspotListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/space/${encodeURIComponent(String(params.id))}/infohotspot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Infohotspot list of spaces.
   * @param params The `MemberService.GetInfoHotspotListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getInfoHotspotList(params: MemberService.GetInfoHotspotListParams): __Observable<null> {
    return this.getInfoHotspotListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete images of member.
   * @param params The `MemberService.DeleteMultipleImageParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Delete multiple images.
   */
  deleteMultipleImageResponse(params: MemberService.DeleteMultipleImageParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/space/${encodeURIComponent(String(params.id))}/media/bulkDelete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete images of member.
   * @param params The `MemberService.DeleteMultipleImageParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Delete multiple images.
   */
  deleteMultipleImage(params: MemberService.DeleteMultipleImageParams): __Observable<null> {
    return this.deleteMultipleImageResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Validate space object.
   * @param params The `MemberService.ValidateSpaceObjectParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  validateSpaceObjectResponse(params: MemberService.ValidateSpaceObjectParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member/space/validate/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Validate space object.
   * @param params The `MemberService.ValidateSpaceObjectParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  validateSpaceObject(params: MemberService.ValidateSpaceObjectParams): __Observable<null> {
    return this.validateSpaceObjectResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Verify email.
   * @param id undefined
   */
  verifyEmailResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/activate/link/${encodeURIComponent(String(id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Verify email.
   * @param id undefined
   */
  verifyEmail(id: string): __Observable<null> {
    return this.verifyEmailResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get List of space category.
   * @param params The `MemberService.GetSpaceCategoryParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getSpaceCategoryResponse(params: MemberService.GetSpaceCategoryParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/space/category`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get List of space category.
   * @param params The `MemberService.GetSpaceCategoryParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getSpaceCategory(params: MemberService.GetSpaceCategoryParams): __Observable<null> {
    return this.getSpaceCategoryResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get list of company.
   * @param params The `MemberService.GetCompanyListParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getCompanyListResponse(params: MemberService.GetCompanyListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/company`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get list of company.
   * @param params The `MemberService.GetCompanyListParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getCompanyList(params: MemberService.GetCompanyListParams): __Observable<null> {
    return this.getCompanyListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Create hotspot.
   * @param params The `MemberService.CreateHotspotParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Craete hotspot object
   */
  createHotspotResponse(params: MemberService.CreateHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/media/hotspot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Create hotspot.
   * @param params The `MemberService.CreateHotspotParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Craete hotspot object
   */
  createHotspot(params: MemberService.CreateHotspotParams): __Observable<null> {
    return this.createHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update hotspot.
   * @param params The `MemberService.UpdateHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update hotspot object
   */
  updateHotspotResponse(params: MemberService.UpdateHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/media/hotspot/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update hotspot.
   * @param params The `MemberService.UpdateHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update hotspot object
   */
  updateHotspot(params: MemberService.UpdateHotspotParams): __Observable<null> {
    return this.updateHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete hotspot.
   * @param params The `MemberService.DeleteHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteHotspotResponse(params: MemberService.DeleteHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/media/hotspot/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete hotspot.
   * @param params The `MemberService.DeleteHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteHotspot(params: MemberService.DeleteHotspotParams): __Observable<null> {
    return this.deleteHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update space config.
   * @param params The `MemberService.UpdateSpaceConfigParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update space config object
   */
  updateSpaceConfigResponse(params: MemberService.UpdateSpaceConfigParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/space/config/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update space config.
   * @param params The `MemberService.UpdateSpaceConfigParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update space config object
   */
  updateSpaceConfig(params: MemberService.UpdateSpaceConfigParams): __Observable<null> {
    return this.updateSpaceConfigResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Set as initial view.
   * @param params The `MemberService.SetInitialViewParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  setInitialViewResponse(params: MemberService.SetInitialViewParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/space/media/${encodeURIComponent(String(params.id))}/initialView`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Set as initial view.
   * @param params The `MemberService.SetInitialViewParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  setInitialView(params: MemberService.SetInitialViewParams): __Observable<null> {
    return this.setInitialViewResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Set as initial view.
   * @param params The `MemberService.PublishSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  publishSpaceResponse(params: MemberService.PublishSpaceParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member/space/${encodeURIComponent(String(params.id))}/status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Set as initial view.
   * @param params The `MemberService.PublishSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  publishSpace(params: MemberService.PublishSpaceParams): __Observable<null> {
    return this.publishSpaceResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Show or hide info hotspot.
   * @param params The `MemberService.ShowHideInfoParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  showHideInfoResponse(params: MemberService.ShowHideInfoParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/media/spaceinfo/${encodeURIComponent(String(params.id))}/toggle`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Show or hide info hotspot.
   * @param params The `MemberService.ShowHideInfoParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  showHideInfo(params: MemberService.ShowHideInfoParams): __Observable<null> {
    return this.showHideInfoResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Create hotspot.
   * @param params The `MemberService.CreateInfoHotspotParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Craete info hotspot object
   */
  createInfoHotspotResponse(params: MemberService.CreateInfoHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/media/spaceinfo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Create hotspot.
   * @param params The `MemberService.CreateInfoHotspotParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Craete info hotspot object
   */
  createInfoHotspot(params: MemberService.CreateInfoHotspotParams): __Observable<null> {
    return this.createInfoHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update hotspot.
   * @param params The `MemberService.UpdateInfoHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update infohotspot object
   */
  updateInfoHotspotResponse(params: MemberService.UpdateInfoHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/media/spaceinfo/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update hotspot.
   * @param params The `MemberService.UpdateInfoHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update infohotspot object
   */
  updateInfoHotspot(params: MemberService.UpdateInfoHotspotParams): __Observable<null> {
    return this.updateInfoHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete Info hotspot.
   * @param params The `MemberService.DeleteInfoHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteInfoHotspotResponse(params: MemberService.DeleteInfoHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/media/spaceinfo/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete Info hotspot.
   * @param params The `MemberService.DeleteInfoHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteInfoHotspot(params: MemberService.DeleteInfoHotspotParams): __Observable<null> {
    return this.deleteInfoHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get list of invoices.
   * @param params The `MemberService.GetInvoicesParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Pagination value for member space list.
   *
   * - `Authorization`:
   */
  getInvoicesResponse(params: MemberService.GetInvoicesParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.paginate != null) __params = __params.set('paginate', params.paginate.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/invoice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get list of invoices.
   * @param params The `MemberService.GetInvoicesParams` containing the following parameters:
   *
   * - `paginate`: Limit value for pagination.
   *
   * - `page`: Pagination value for member space list.
   *
   * - `Authorization`:
   */
  getInvoices(params: MemberService.GetInvoicesParams): __Observable<null> {
    return this.getInvoicesResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get list of card.
   * @param Authorization undefined
   */
  getPaymentCardResponse(Authorization: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/card`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get list of card.
   * @param Authorization undefined
   */
  getPaymentCard(Authorization: string): __Observable<null> {
    return this.getPaymentCardResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get list of card.
   * @param Authorization undefined
   */
  getCurrentSubscriptionResponse(Authorization: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/subscription`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get list of card.
   * @param Authorization undefined
   */
  getCurrentSubscription(Authorization: string): __Observable<null> {
    return this.getCurrentSubscriptionResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get floor plan.
   * @param params The `MemberService.GetFloorPlanParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  getFloorPlanResponse(params: MemberService.GetFloorPlanParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/spaces/${encodeURIComponent(String(params.id))}/floorplan`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get floor plan.
   * @param params The `MemberService.GetFloorPlanParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  getFloorPlan(params: MemberService.GetFloorPlanParams): __Observable<null> {
    return this.getFloorPlanResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Create floorplan hotspot.
   * @param params The `MemberService.CreateFlooplanHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Floorplan hotspot body
   */
  createFlooplanHotspotResponse(params: MemberService.CreateFlooplanHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/floorplan/${encodeURIComponent(String(params.id))}/hotspot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Create floorplan hotspot.
   * @param params The `MemberService.CreateFlooplanHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Floorplan hotspot body
   */
  createFlooplanHotspot(params: MemberService.CreateFlooplanHotspotParams): __Observable<null> {
    return this.createFlooplanHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Create floorplan hotspot.
   * @param params The `MemberService.UpdateFlooplanHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Floorplan hotspot body
   */
  updateFlooplanHotspotResponse(params: MemberService.UpdateFlooplanHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/floorplan/hotspot/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Create floorplan hotspot.
   * @param params The `MemberService.UpdateFlooplanHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Floorplan hotspot body
   */
  updateFlooplanHotspot(params: MemberService.UpdateFlooplanHotspotParams): __Observable<null> {
    return this.updateFlooplanHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete hotspot of floorplan.
   * @param params The `MemberService.DeleteFloorplanHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteFloorplanHotspotResponse(params: MemberService.DeleteFloorplanHotspotParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/floorplan/hotspot/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete hotspot of floorplan.
   * @param params The `MemberService.DeleteFloorplanHotspotParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteFloorplanHotspot(params: MemberService.DeleteFloorplanHotspotParams): __Observable<null> {
    return this.deleteFloorplanHotspotResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Create camera subscription.
   * @param params The `MemberService.AddCameraSubscriptionParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Payment cvv code body
   */
  addCameraSubscriptionResponse(params: MemberService.AddCameraSubscriptionParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/camera`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Create camera subscription.
   * @param params The `MemberService.AddCameraSubscriptionParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Payment cvv code body
   */
  addCameraSubscription(params: MemberService.AddCameraSubscriptionParams): __Observable<null> {
    return this.addCameraSubscriptionResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update media title.
   * @param params The `MemberService.UpdateMediaTitleParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update media title
   */
  updateMediaTitleResponse(params: MemberService.UpdateMediaTitleParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/space/media/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update media title.
   * @param params The `MemberService.UpdateMediaTitleParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update media title
   */
  updateMediaTitle(params: MemberService.UpdateMediaTitleParams): __Observable<null> {
    return this.updateMediaTitleResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete single media.
   * @param params The `MemberService.DeleteSingleMediaParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteSingleMediaResponse(params: MemberService.DeleteSingleMediaParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/space/media/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete single media.
   * @param params The `MemberService.DeleteSingleMediaParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteSingleMedia(params: MemberService.DeleteSingleMediaParams): __Observable<null> {
    return this.deleteSingleMediaResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Remove camera subscription.
   * @param Authorization undefined
   */
  removeCameraSubscriptionResponse(Authorization: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/camera/remove`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Remove camera subscription.
   * @param Authorization undefined
   */
  removeCameraSubscription(Authorization: string): __Observable<null> {
    return this.removeCameraSubscriptionResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Download invoice.
   * @param params The `MemberService.DownloadInvoiceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  downloadInvoiceResponse(params: MemberService.DownloadInvoiceParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/invoice/${encodeURIComponent(String(params.id))}/pdf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Download invoice.
   * @param params The `MemberService.DownloadInvoiceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  downloadInvoice(params: MemberService.DownloadInvoiceParams): __Observable<null> {
    return this.downloadInvoiceResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Enable disable vr links.
   * @param Authorization undefined
   */
  enableDisableVrLinksResponse(Authorization: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/vrtoggle`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Enable disable vr links.
   * @param Authorization undefined
   */
  enableDisableVrLinks(Authorization: string): __Observable<null> {
    return this.enableDisableVrLinksResponse(Authorization).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update orientation of media.
   * @param params The `MemberService.SetMediaOrientationParams` containing the following parameters:
   *
   * - `mediaId`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update position orienation value
   */
  setMediaOrientationResponse(params: MemberService.SetMediaOrientationParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/space/media/${encodeURIComponent(String(params.mediaId))}/orientation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update orientation of media.
   * @param params The `MemberService.SetMediaOrientationParams` containing the following parameters:
   *
   * - `mediaId`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update position orienation value
   */
  setMediaOrientation(params: MemberService.SetMediaOrientationParams): __Observable<null> {
    return this.setMediaOrientationResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete info media data.
   * @param params The `MemberService.DeleteInfoMediaParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteInfoMediaResponse(params: MemberService.DeleteInfoMediaParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/spaceinfo/${encodeURIComponent(String(params.id))}/media`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete info media data.
   * @param params The `MemberService.DeleteInfoMediaParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteInfoMedia(params: MemberService.DeleteInfoMediaParams): __Observable<null> {
    return this.deleteInfoMediaResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Validate space object.
   * @param params The `MemberService.ValidateReuploadSpaceObjectParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  validateReuploadSpaceObjectResponse(params: MemberService.ValidateReuploadSpaceObjectParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/member/space/reuploadValidate/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Validate space object.
   * @param params The `MemberService.ValidateReuploadSpaceObjectParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  validateReuploadSpaceObject(params: MemberService.ValidateReuploadSpaceObjectParams): __Observable<null> {
    return this.validateReuploadSpaceObjectResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Reupload new dollhouse.
   * @param params The `MemberService.RequestNewDollhouseParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Reupload new dollhouse.
   */
  requestNewDollhouseResponse(params: MemberService.RequestNewDollhouseParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/space/processfile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Reupload new dollhouse.
   * @param params The `MemberService.RequestNewDollhouseParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Reupload new dollhouse.
   */
  requestNewDollhouse(params: MemberService.RequestNewDollhouseParams): __Observable<null> {
    return this.requestNewDollhouseResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete audio of space.
   * @param params The `MemberService.DeleteAudioSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteAudioSpaceResponse(params: MemberService.DeleteAudioSpaceParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/member/space/audio/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete audio of space.
   * @param params The `MemberService.DeleteAudioSpaceParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteAudioSpace(params: MemberService.DeleteAudioSpaceParams): __Observable<null> {
    return this.deleteAudioSpaceResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Snapshot list.
   * @param params The `MemberService.GetSnapshotListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getSnapshotListResponse(params: MemberService.GetSnapshotListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/${encodeURIComponent(String(params.id))}/snapshot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Snapshot list.
   * @param params The `MemberService.GetSnapshotListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getSnapshotList(params: MemberService.GetSnapshotListParams): __Observable<null> {
    return this.getSnapshotListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete Snapshot.
   * @param params The `MemberService.DeleteSnapshotsParams` containing the following parameters:
   *
   * - `id`: Snapshot Uuid value.
   *
   * - `Authorization`:
   */
  deleteSnapshotsResponse(params: MemberService.DeleteSnapshotsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/snapshot/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete Snapshot.
   * @param params The `MemberService.DeleteSnapshotsParams` containing the following parameters:
   *
   * - `id`: Snapshot Uuid value.
   *
   * - `Authorization`:
   */
  deleteSnapshots(params: MemberService.DeleteSnapshotsParams): __Observable<null> {
    return this.deleteSnapshotsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete Multiple Snapshot.
   * @param params The `MemberService.DeleteMultipleSnapshotsParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Delete multiple snapshots.
   */
  deleteMultipleSnapshotsResponse(params: MemberService.DeleteMultipleSnapshotsParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/snapshot/bulkDelete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete Multiple Snapshot.
   * @param params The `MemberService.DeleteMultipleSnapshotsParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Delete multiple snapshots.
   */
  deleteMultipleSnapshots(params: MemberService.DeleteMultipleSnapshotsParams): __Observable<null> {
    return this.deleteMultipleSnapshotsResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Highlight reel list.
   * @param params The `MemberService.GetHighlightReelListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getHighlightReelListResponse(params: MemberService.GetHighlightReelListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/${encodeURIComponent(String(params.id))}/highlightReel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Highlight reel list.
   * @param params The `MemberService.GetHighlightReelListParams` containing the following parameters:
   *
   * - `id`: Space Uuid value.
   *
   * - `Authorization`:
   */
  getHighlightReelList(params: MemberService.GetHighlightReelListParams): __Observable<null> {
    return this.getHighlightReelListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Add to highlight reel.
   * @param params The `MemberService.PostHighlightReelParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Add to highlight reel.
   */
  postHighlightReelResponse(params: MemberService.PostHighlightReelParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/highlightReel`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Add to highlight reel.
   * @param params The `MemberService.PostHighlightReelParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Add to highlight reel.
   */
  postHighlightReel(params: MemberService.PostHighlightReelParams): __Observable<null> {
    return this.postHighlightReelResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Add Caption to highlight reel.
   * @param params The `MemberService.PostHighlightReelCaptionParams` containing the following parameters:
   *
   * - `id`: Highlightreel Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Add Caption to highlight reel.
   */
  postHighlightReelCaptionResponse(params: MemberService.PostHighlightReelCaptionParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/highlightReel/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Add Caption to highlight reel.
   * @param params The `MemberService.PostHighlightReelCaptionParams` containing the following parameters:
   *
   * - `id`: Highlightreel Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Add Caption to highlight reel.
   */
  postHighlightReelCaption(params: MemberService.PostHighlightReelCaptionParams): __Observable<null> {
    return this.postHighlightReelCaptionResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete hightlight reel.
   * @param params The `MemberService.DeleteHighlightReelParams` containing the following parameters:
   *
   * - `id`: Highlightreel Uuid value.
   *
   * - `Authorization`:
   */
  deleteHighlightReelResponse(params: MemberService.DeleteHighlightReelParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/highlightReel/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete hightlight reel.
   * @param params The `MemberService.DeleteHighlightReelParams` containing the following parameters:
   *
   * - `id`: Highlightreel Uuid value.
   *
   * - `Authorization`:
   */
  deleteHighlightReel(params: MemberService.DeleteHighlightReelParams): __Observable<null> {
    return this.deleteHighlightReelResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Swap position of highlight reel.
   * @param params The `MemberService.PostHighlightReelPositionParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Swap position of highlight reel.
   */
  postHighlightReelPositionResponse(params: MemberService.PostHighlightReelPositionParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/highlightReel/position`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Swap position of highlight reel.
   * @param params The `MemberService.PostHighlightReelPositionParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Swap position of highlight reel.
   */
  postHighlightReelPosition(params: MemberService.PostHighlightReelPositionParams): __Observable<null> {
    return this.postHighlightReelPositionResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update hotspot.
   * @param params The `MemberService.UpdateHotspotOrientationParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update hotspot object
   */
  updateHotspotOrientationResponse(params: MemberService.UpdateHotspotOrientationParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/media/hotspot/${encodeURIComponent(String(params.id))}/orientation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update hotspot.
   * @param params The `MemberService.UpdateHotspotOrientationParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update hotspot object
   */
  updateHotspotOrientation(params: MemberService.UpdateHotspotOrientationParams): __Observable<null> {
    return this.updateHotspotOrientationResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module MemberService {

  /**
   * Parameters for updateMember
   */
  export interface UpdateMemberParams {
    Authorization: string;

    /**
     * Update member profile object
     */
    body?: {};
  }

  /**
   * Parameters for changePassword
   */
  export interface ChangePasswordParams {
    Authorization: string;

    /**
     * Update member password object
     */
    body?: {};
  }

  /**
   * Parameters for getMemberSpace
   */
  export interface GetMemberSpaceParams {

    /**
     * Limit value for pagination.
     */
    paginate: number;

    /**
     * Pagination value for member space list.
     */
    page: number;
    Authorization: string;

    /**
     * Status of Space.
     */
    status?: string;

    /**
     * Keywords value for filter.
     */
    keywords?: string;

    /**
     * Category value for filter.
     */
    categoryId?: string;
  }

  /**
   * Parameters for createMemberSpace
   */
  export interface CreateMemberSpaceParams {
    Authorization: string;

    /**
     * Create member space object
     */
    body?: {};
  }

  /**
   * Parameters for getMemberSpaceDetails
   */
  export interface GetMemberSpaceDetailsParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for updateMemberSpace
   */
  export interface UpdateMemberSpaceParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update member space object
     */
    body?: {};
  }

  /**
   * Parameters for deleteMemberSpace
   */
  export interface DeleteMemberSpaceParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for deleteFloorplan
   */
  export interface DeleteFloorplanParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for getMemberSpaceMediaDetails
   */
  export interface GetMemberSpaceMediaDetailsParams {

    /**
     * Space Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for getHotspotList
   */
  export interface GetHotspotListParams {

    /**
     * Space Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for getInfoHotspotList
   */
  export interface GetInfoHotspotListParams {

    /**
     * Space Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for deleteMultipleImage
   */
  export interface DeleteMultipleImageParams {

    /**
     * Space Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Delete multiple images.
     */
    body?: {};
  }

  /**
   * Parameters for validateSpaceObject
   */
  export interface ValidateSpaceObjectParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for getSpaceCategory
   */
  export interface GetSpaceCategoryParams {
    Authorization: string;

    /**
     * Language short code.
     */
    lang?: string;
  }

  /**
   * Parameters for getCompanyList
   */
  export interface GetCompanyListParams {
    Authorization: string;

    /**
     * Language short code.
     */
    lang?: string;
  }

  /**
   * Parameters for createHotspot
   */
  export interface CreateHotspotParams {
    Authorization: string;

    /**
     * Craete hotspot object
     */
    body?: {};
  }

  /**
   * Parameters for updateHotspot
   */
  export interface UpdateHotspotParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update hotspot object
     */
    body?: {};
  }

  /**
   * Parameters for deleteHotspot
   */
  export interface DeleteHotspotParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for updateSpaceConfig
   */
  export interface UpdateSpaceConfigParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update space config object
     */
    body?: {};
  }

  /**
   * Parameters for setInitialView
   */
  export interface SetInitialViewParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for publishSpace
   */
  export interface PublishSpaceParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for showHideInfo
   */
  export interface ShowHideInfoParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for createInfoHotspot
   */
  export interface CreateInfoHotspotParams {
    Authorization: string;

    /**
     * Craete info hotspot object
     */
    body?: {};
  }

  /**
   * Parameters for updateInfoHotspot
   */
  export interface UpdateInfoHotspotParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update infohotspot object
     */
    body?: {};
  }

  /**
   * Parameters for deleteInfoHotspot
   */
  export interface DeleteInfoHotspotParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for getInvoices
   */
  export interface GetInvoicesParams {

    /**
     * Limit value for pagination.
     */
    paginate: number;

    /**
     * Pagination value for member space list.
     */
    page: number;
    Authorization: string;
  }

  /**
   * Parameters for getFloorPlan
   */
  export interface GetFloorPlanParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for createFlooplanHotspot
   */
  export interface CreateFlooplanHotspotParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Floorplan hotspot body
     */
    body?: {};
  }

  /**
   * Parameters for updateFlooplanHotspot
   */
  export interface UpdateFlooplanHotspotParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Floorplan hotspot body
     */
    body?: {};
  }

  /**
   * Parameters for deleteFloorplanHotspot
   */
  export interface DeleteFloorplanHotspotParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for addCameraSubscription
   */
  export interface AddCameraSubscriptionParams {
    Authorization: string;

    /**
     * Payment cvv code body
     */
    body?: {};
  }

  /**
   * Parameters for updateMediaTitle
   */
  export interface UpdateMediaTitleParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update media title
     */
    body?: {};
  }

  /**
   * Parameters for deleteSingleMedia
   */
  export interface DeleteSingleMediaParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for downloadInvoice
   */
  export interface DownloadInvoiceParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for setMediaOrientation
   */
  export interface SetMediaOrientationParams {

    /**
     * Uuid value.
     */
    mediaId: string;
    Authorization: string;

    /**
     * Update position orienation value
     */
    body?: {};
  }

  /**
   * Parameters for deleteInfoMedia
   */
  export interface DeleteInfoMediaParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for validateReuploadSpaceObject
   */
  export interface ValidateReuploadSpaceObjectParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for requestNewDollhouse
   */
  export interface RequestNewDollhouseParams {
    Authorization: string;

    /**
     * Reupload new dollhouse.
     */
    body?: {};
  }

  /**
   * Parameters for deleteAudioSpace
   */
  export interface DeleteAudioSpaceParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for getSnapshotList
   */
  export interface GetSnapshotListParams {

    /**
     * Space Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for deleteSnapshots
   */
  export interface DeleteSnapshotsParams {

    /**
     * Snapshot Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for deleteMultipleSnapshots
   */
  export interface DeleteMultipleSnapshotsParams {
    Authorization: string;

    /**
     * Delete multiple snapshots.
     */
    body?: {};
  }

  /**
   * Parameters for getHighlightReelList
   */
  export interface GetHighlightReelListParams {

    /**
     * Space Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for postHighlightReel
   */
  export interface PostHighlightReelParams {
    Authorization: string;

    /**
     * Add to highlight reel.
     */
    body?: {};
  }

  /**
   * Parameters for postHighlightReelCaption
   */
  export interface PostHighlightReelCaptionParams {

    /**
     * Highlightreel Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Add Caption to highlight reel.
     */
    body?: {};
  }

  /**
   * Parameters for deleteHighlightReel
   */
  export interface DeleteHighlightReelParams {

    /**
     * Highlightreel Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for postHighlightReelPosition
   */
  export interface PostHighlightReelPositionParams {
    Authorization: string;

    /**
     * Swap position of highlight reel.
     */
    body?: {};
  }

  /**
   * Parameters for updateHotspotOrientation
   */
  export interface UpdateHotspotOrientationParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update hotspot object
     */
    body?: {};
  }
}

export { MemberService }
